import { render, staticRenderFns } from "./GroupStandardDeclarationDownload.vue?vue&type=template&id=44ceb293&scoped=true"
import script from "./GroupStandardDeclarationDownload.vue?vue&type=script&lang=js"
export * from "./GroupStandardDeclarationDownload.vue?vue&type=script&lang=js"
import style0 from "./GroupStandardDeclarationDownload.vue?vue&type=style&index=0&id=44ceb293&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d97cc52897b1b5edd1ee8818c6a75fc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ceb293",
  null
  
)

export default component.exports